export const CATALOG_LOAD_SUCCESS = 'CATALOG_LOAD_SUCCESS';
export const CATALOG_LOAD_ERROR = 'CATALOG_LOAD_ERROR';
export const CATALOG_ADD_TO_LIST = 'CATALOG_ADD_TO_LIST';
export const CATALOG_REMOVE_FROM_LIST = 'CATALOG_REMOVE_FROM_LIST';
export const CATALOG_UPDATE_IN_LIST = 'CATALOG_UPDATE_IN_LIST';
